// extracted by mini-css-extract-plugin
module.exports = {"add":"Button_add__6bU7-","delete":"Button_delete__2cCUy","ghost":"Button_ghost__v_8dN"};